import React, { FunctionComponent } from "react";
import Geolocator from "./geolocator";

const Welcome: FunctionComponent<WelcomeProps> = ({ onViewport }) => {
  return (
    <div
      id="modal"
      className="tw-mx-auto sm:tw-my-auto @sm/main:tw-my-auto tw-pointer-events-auto lg:tw-drop-shadow-md @lg/main:tw-drop-shadow-md"
    >
      <Geolocator
        onDone={() => onViewport()}
        className="tw-max-h-fit tw-w-full sm:tw-w-80 @sm/main:tw-w-80 tw-m-auto"
      />
    </div>
  );
};

export type WelcomeProps = {
  onViewport: VoidFunction;
};

export default React.memo(Welcome);
